<template>
  <div class="h-100">
    <main role="main" class="h-100">
        <common-master-table
          primary-key="sortingSerialId"
          table-no="mstSorting"
          table-api="master/sorting"
          ref="commonMasterTable"
          :editable="editableMixin.sorting"
          :addable="editableMixin.sorting"
          :mapping-no="`ie-sorting`"
          socket-entity="SORTING_SOCKET"
        />
    </main>
  </div>
</template>

<script>
import CommonMasterTable from '../custom-components/CommonMasterTable'
import RouterUtils from '../../_helpers/router.util'
export default {
  components: {
    // コンポーネント分割化
    CommonMasterTable
  },
  data() {
    return {
      removeKeys: [],
      updateQueryStr: ''
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.hasOwnProperty('limit') && Object.keys(to.query).length === 1) {
      RouterUtils.correctTableRowsLimitParam(to.query)
      this.$refs.commonMasterTable.initData()
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mst-tables/SortingMaster.vue